type MediaTiming = {
    created_at?: unknown
    createdAt?: unknown
    attached_at?: unknown
    attachedAt?: unknown
    blob_created_at?: unknown
    blobCreatedAt?: unknown
}

export function firstValidMediaTimestamp(...values: unknown[]): unknown {
    for (const value of values) {
        if (!value) continue
        const parsed = Date.parse(String(value))
        if (Number.isFinite(parsed)) return value
    }
    return null
}

function firstTimestampMs(...values: unknown[]): number {
    const timestamp = firstValidMediaTimestamp(...values)
    return timestamp ? Date.parse(String(timestamp)) : 0
}

function mediaTiming(item: unknown): MediaTiming | undefined {
    return item && typeof item === 'object' ? (item as MediaTiming) : undefined
}

function primaryTimestampMs(item: unknown): number {
    const timing = mediaTiming(item)
    return firstTimestampMs(
        timing?.created_at,
        timing?.createdAt,
        timing?.attached_at,
        timing?.attachedAt,
        timing?.blob_created_at,
        timing?.blobCreatedAt,
    )
}

function attachedAtMs(item: unknown): number {
    const timing = mediaTiming(item)
    return firstTimestampMs(timing?.attached_at, timing?.attachedAt)
}

function blobCreatedAtMs(item: unknown): number {
    const timing = mediaTiming(item)
    return firstTimestampMs(timing?.blob_created_at, timing?.blobCreatedAt)
}

// APIs serialize media newest-first. Display surfaces restore chronological order. Attachment
// time is a necessary tie-breaker because legacy created_at strings have only second precision,
// while several files selected together are attached a few milliseconds apart.
export function sortMediaByCreation<T>(items: readonly T[]): T[] {
    return items
        .map((item, index) => ({ item, index }))
        .sort((left, right) => {
            const primaryDiff = primaryTimestampMs(left.item) - primaryTimestampMs(right.item)
            if (primaryDiff) return primaryDiff

            const attachedDiff = attachedAtMs(left.item) - attachedAtMs(right.item)
            if (attachedDiff) return attachedDiff

            const blobCreatedDiff = blobCreatedAtMs(left.item) - blobCreatedAtMs(right.item)
            return blobCreatedDiff || left.index - right.index
        })
        .map(({ item }) => item)
}
